/**
 * The tabs of the notifications page. A route's address is checked in the part of it that loads
 * with every page, so this stays away from the page's own code.
 */
export const NOTIFICATION_TABS = ["activity", "invitations", "requests"] as const;
export type NotificationTab = (typeof NOTIFICATION_TABS)[number];
